export function useRecording() {
  const startRecording = () => {
    ;(window as any).ReactNativeWebView?.postMessage(
      JSON.stringify({
        action: 'start',
      }),
    )
  }

  function stopRecording() {
    ;(window as any).ReactNativeWebView?.postMessage(
      JSON.stringify({
        action: 'stop',
      }),
    )
  }

  function uploadNotesUrl(url: any) {
    ;(window as any).ReactNativeWebView?.postMessage(
      JSON.stringify({
        action: 'upload-url',
        url,
      }),
    )
    // setRecordingUploadUrl(url)
  }

  return {
    startRecording,
    stopRecording,
    uploadNotesUrl,
  }
}
